import { Put } from '../helpers';
import { Profile } from '@/types/profile.types';

export const UpdateAdminProfile = async (profile: Profile): Promise<{ token: string }> => {
  return Put({ url: '/v3/admin/auth/update-profile', body: { profile } });
};
